import { useState, type FormEvent } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router';
import { useLogin, useMe } from '../api/auth';
import { ApiError } from '../api/client';
import { Logo } from '../components/Logo';

/** Obrazovka prihlásenia podľa design/Login.dc.html. */
export function LoginPage() {
  const me = useMe();
  const login = useLogin();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  if (me.data) return <Navigate to="/" replace />;

  const from = (location.state as { from?: string } | null)?.from ?? '/';

  async function submit(e: FormEvent) {
    e.preventDefault();
    try {
      await login.mutateAsync({ email, password });
      navigate(from, { replace: true });
    } catch { /* chyba je v login.error */ }
  }

  const error = login.error instanceof ApiError ? login.error : null;

  return (
    <main className="grid min-h-full place-items-center px-6 py-10">
      <div className="flex w-[min(410px,100%)] flex-col gap-[30px]">
        <div className="flex flex-col items-center gap-2.5 text-center text-white">
          <Logo size="lg" />
          <span className="text-[10px] font-semibold tracking-[1.2px] text-faint">WORDPRESS VULNERABILITY MONITORING</span>
        </div>

        <form onSubmit={submit} className="card flex flex-col gap-[22px] p-[30px]" noValidate>
          <label className="field">
            <span>E-mail</span>
            <span className="fbox">
              <input
                type="email"
                name="email"
                autoComplete="username"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </span>
          </label>
          <label className="field">
            <span>Heslo</span>
            <span className="fbox">
              <input
                type="password"
                name="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </span>
          </label>

          {error && (
            <p role="alert" className="rounded-panel border border-sev-critical/40 bg-sev-critical/10 px-3.5 py-2.5 text-[12.5px] text-ink">
              {error.status === 429
                ? `Príliš veľa pokusov. Skús znova o ${Math.max(1, Math.ceil((error.retryAfter ?? 60) / 60))} min.`
                : error.message}
            </p>
          )}

          <button type="submit" className="btn btn-p h-11 justify-center" disabled={login.isPending}>
            {login.isPending ? 'Prihlasujem…' : 'Prihlásiť sa'}
          </button>
        </form>

        <p className="text-center text-[11.5px] leading-relaxed text-faint">
          Registrácia je zatvorená. Účty vytvára vlastník inštancie.
          <br />
          <span className="text-ghost">v2.0.0 &nbsp;·&nbsp; interná inštancia</span>
        </p>
      </div>
    </main>
  );
}
